import { useState } from 'react';
import usePageMetadata from '@/hooks/usePageMetadata';
import { MIXPANEL_EVENT, RevenueDashboardWidget } from '@/utils/mixpanelUtils/events';
import { trackContentPerformanceEventIfApplicable } from '@/routes/ContentPerformancePage/trackingUtils';

type LevelView = 'networks' | 'shows' | 'episodes';

type LevelTabChangeTrigger = 'filter' | 'tabClick';

interface UseDataLevelTabsResult {
  activeView: LevelView;
  handleViewChange: (view: LevelView, trigger?: LevelTabChangeTrigger) => void;
}

/**
 * Manages the active view in the Content Performance level tabs bar.
 */
const useDataLevelTabs = (): UseDataLevelTabsResult => {
  const [activeView, setActiveView] = useState<LevelView>('networks');
  const { page } = usePageMetadata();

  const handleViewChange = (
    view: LevelView,
    trigger: LevelTabChangeTrigger = 'tabClick'
  ): void => {
    // Skip when already on this tab
    if (view === activeView) return;

    trackContentPerformanceEventIfApplicable(
      page,
      MIXPANEL_EVENT.contentPerformance.levelTabs.tabChanged,
      { tab: view, trigger },
      RevenueDashboardWidget.ContentPerformanceDataLevelTabs
    );
    setActiveView(view);
  };

  return { activeView, handleViewChange };
};

export { useDataLevelTabs };
export type { LevelView, LevelTabChangeTrigger };
